import { type Conversation } from "shared/apiClient";
import { type Noticeboard } from "shared/lib";

import { useGetReportContent } from "shared/hooks";

export function useTreeModuleQuestionTitle(
  conversation: Conversation | undefined | null,
  noticeboardData: Noticeboard | undefined | null,
): string {
  const { getConfig } = useGetReportContent({
    conversation,
    noticeboardData,
  });

  const { content: treeModuleQuestionTitle } = getConfig(
    "enquiry.tree_module_title",
  );

  return treeModuleQuestionTitle;
}
